/* aw-pdp.js — de galerij springt naar de foto van de gekozen kleur.
 *
 * Dit kan pas sinds twee eerdere stappen:
 *   1. `hide_variants` staat uit, anders zitten de foto's van de andere kleuren
 *      niet eens in de galerij;
 *   2. de galerij is onze eigen `<aw-media-galerij>`, anders sorteert Horizon de
 *      foto's om (de gekozen variant naar plek 1) EN vervangt hij de hele
 *      galerij bij elke variantklik — er is dan niets om naartoe te bewegen.
 *
 * Overgenomen van The Hills (`hzo-pdp.js`), waar dit al gemeten en goedgekeurd
 * is. Twee dingen daaruit zijn belangrijk en niet vanzelfsprekend:
 *
 * NIET `slideshow.select()` gebruiken. In Horizons `slideshow.js` staat:
 *     // If jump is more than 1 or we looped, do the placeholder + reorder trick
 *     if (requestedIndex < current) currentSlide.before(targetSlide);
 * Bij een sprong van meer dan één dia haalt hij de doeldia uit de rij en zet hem
 * naast de huidige. Zet hij die ervoor — dus bij terugspringen — dan verspringt
 * de scrollpositie op datzelfde moment. Dat is het geflikker, en het gebeurt
 * daarom alleen achteruit.
 *
 * `scroll-snap-type` moet tijdens de beweging UIT. Bij een sprong over meerdere
 * snap-punten klapt de browser meteen naar het doel in plaats van eroverheen te
 * animeren; over één snap-punt animeert hij wel. Dat is precies het verschil
 * tussen "5 naar 4 gaat soepel" en "5 naar 3 is instant".
 */
(() => {
  const BUREAU = window.matchMedia('(min-width: 750px)');
  const RUSTIG = window.matchMedia('(prefers-reduced-motion: reduce)');

  function fotoKern(url) {
    try {
      const schoon = String(url).replace(/^url\(['"]?/, '').replace(/['"]?\)$/, '');
      const bestand = new URL(schoon, location.origin).pathname.split('/').pop();
      return bestand.split('.')[0].split('_')[0];
    } catch (e) {
      return '';
    }
  }

  function glijNaar(strook, links, zacht) {
    if (!zacht) { strook.scrollTo({ left: links, behavior: 'auto' }); return; }
    const snapWas = strook.style.scrollSnapType;
    let hersteld = false;
    const herstel = () => {
      if (hersteld) return;
      hersteld = true;
      strook.style.scrollSnapType = snapWas;
    };
    strook.style.scrollSnapType = 'none';
    strook.addEventListener('scrollend', herstel, { once: true });
    setTimeout(herstel, 900);
    strook.scrollTo({ left: links, behavior: 'smooth' });
  }

  function naarVariantFoto() {
    const galerij = document.querySelector('aw-media-galerij');
    if (!galerij) return;

    const aan = document.querySelector('fieldset.aw-kleurveld input:checked');
    if (!aan) return;
    const label = aan.closest('label');
    if (!label) return;

    /* Onze kleurvakjes dragen de variantfoto als achtergrond (aw-variant.js). */
    const zoek = fotoKern(getComputedStyle(label).backgroundImage);
    if (!zoek) return;

    const dias = [...galerij.querySelectorAll('slideshow-slide')];
    const index = dias.findIndex((s) => {
      const im = s.querySelector('img');
      return im && fotoKern(im.currentSrc || im.src) === zoek;
    });
    if (index < 0) return;

    const strook = galerij.querySelector('slideshow-slides');
    const doel = dias[index];
    if (!strook || !doel) return;

    /* de buurdia's alvast laden, anders glijd je naar een leeg vak */
    [index - 1, index, index + 1].forEach((i) => {
      const d = dias[i];
      const im = d && d.querySelector('img');
      if (im && im.loading === 'lazy') im.loading = 'eager';
    });

    glijNaar(strook, doel.offsetLeft - strook.offsetLeft, BUREAU.matches && !RUSTIG.matches);
  }

  document.addEventListener('change', (e) => {
    if (e.target && e.target.closest && e.target.closest('fieldset.aw-kleurveld')) {
      setTimeout(naarVariantFoto, 60);
    }
  }, true);
  document.addEventListener('shopify:section:load', () => setTimeout(naarVariantFoto, 200));
})();

/* ── De sterrenregel scrollt zacht naar de beoordelingen ──────────────────
   Een gewone ankerlink springt hard. De bron onderschept de klik en gebruikt
   `scrollIntoView({behavior:'smooth'})`. Let op: Horizon schuift op het
   BUREAUBLAD in `.page-wrapper` en op de TELEFOON in het venster — daar hoeven
   we niets voor te doen, want `scrollIntoView` vindt zijn eigen scroller. */
(() => {
  document.addEventListener('click', (e) => {
    const link = e.target.closest && e.target.closest('[data-aw-rating-link]');
    if (!link) return;
    const doel = document.querySelector('#aw-reviews-anker') || document.querySelector('.aw-reviews');
    if (!doel) return;
    e.preventDefault();
    const zacht = !matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* NIET `scrollIntoView`. Die landde 90px lager dan de bron (255 tegen 165 op
       390) en `scroll-margin-top` haalde daar niets aan uit — de plakkende kop
       telt bij Horizon al mee in de scrollpositie. Zelf rekenen is voorspelbaar
       en laat zich meten.

       Let op WELKE scroller: Horizon schuift op het bureaublad in
       `.page-wrapper` en op de telefoon in het venster. */
    const wrapper = document.querySelector('.page-wrapper');
    const schuift = wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1;
    const scroller = schuift ? wrapper : (document.scrollingElement || document.documentElement);

    const kop = document.querySelector('header-component.header') || document.querySelector('header');
    /* De bron landt op y165 (390) en y190 (1440). Dat is precies de hoogte van
       zijn plakkende kop (75 en 100) plus de 90 die hij als `scroll-margin-top`
       zet. Wij rekenen datzelfde uit in plaats van op `scroll-margin` te
       vertrouwen, want dat werd bij ons genegeerd. */
    const MARGE = 90;
    const kopHoog = (kop ? Math.round(kop.getBoundingClientRect().height) : 0) + MARGE;

    const nu = schuift ? scroller.scrollTop : (window.scrollY || scroller.scrollTop);
    const doelY = nu + doel.getBoundingClientRect().top - kopHoog;

    const ganaar = (y, hoe) => {
      if (schuift) scroller.scrollTo({ top: y, behavior: hoe });
      else window.scrollTo({ top: y, behavior: hoe });
    };

    ganaar(doelY, zacht ? 'smooth' : 'auto');

    /* NAKOMEN. Onderweg groeit de pagina: blokken met `content-visibility: auto`
       klappen open zodra ze in beeld komen, en dan klopt de plek die we vooraf
       uitrekenden niet meer. Gemeten: we landden 87px te laag. Daarom na het
       glijden één keer bijsturen als het meer dan 4px scheelt. */
    let klaar = false;
    const bijsturen = () => {
      if (klaar) return;
      klaar = true;
      const rest = doel.getBoundingClientRect().top - kopHoog;
      if (Math.abs(rest) > 4) {
        const nu2 = schuift ? scroller.scrollTop : (window.scrollY || scroller.scrollTop);
        ganaar(nu2 + rest, 'auto');
      }
    };
    (schuift ? scroller : window).addEventListener('scrollend', bijsturen, { once: true });
    setTimeout(bijsturen, 1400);
  }, true);
})();
